<template>
    <div class="vh-margin-top">
        <p class="vh-margin-remove" v-if="chips.length">
            You have search / filter:
        </p>

        <vh-badge
            v-for="(item, index) in chips"
            :key="index"
            :item="item"
            @reset="reset(item.query)"/>
    </div>
</template>

<script>

export default
{
    props:
    {
        queries:
        {
            type: Object,

            default:
            {
                'search': 
                {
                    name: '',
                    type: 'search',
                    icon: 'fa-search',
                    query: 'search',
                    options: ''
                },
            },
        },
    },

    data()
    {
        return {
            chips: [],
        };
    },

    created()
    {
        this.initializeChips();
    },

    methods:
    {
        initializeChips()
        {
            const routeQueries = this.$route.query;
            
            const chips = [];

            Object.keys(this.queries).forEach((key) =>
            {

                if (Object.prototype.hasOwnProperty.call(routeQueries, key))
                {
                    const chip = this.queries[key];
                    chip.value = chip.type!='search'
                        ? `${chip.name}: ${chip.options[routeQueries[key]]}`
                        : `${routeQueries[key]}`;
                    
                    chips.unshift(chip);
                }
            });

            this.chips = chips;
        },

        reset(name)
        {
            const query = Object.assign({}, this.$route.query);
            delete query[name];

            this.$router.replace({ query });
        },
    },
    
    watch:
    {
        $route()
        {
            this.initializeChips();
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/query-badge/vh-query-badge.vue